import { render } from "./ArenaManagement.vue?vue&type=template&id=5e31036c&scoped=true"
import script from "./ArenaManagement.vue?vue&type=script&lang=js"
export * from "./ArenaManagement.vue?vue&type=script&lang=js"

import "./ArenaManagement.vue?vue&type=style&index=0&id=5e31036c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e31036c"]])

export default __exports__